import { routerPostCall } from '../../axios';

const cancelPolicyUrl = (policyId) => `/accounts/cancelPolicy/${policyId}`;

const cancelPolicy = (state, params) => {
    const { policyId, cancellationReason } = params;
    const url = cancelPolicyUrl(policyId);
    const payload = {
        cancellationReason,
    };
    return routerPostCall(state, url, payload);
};

export default { cancelPolicy };
